// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a109a162","337":"2ba92f3d","455":"e9b284f8"}[chunkId] + ".chunk.js";
};